import React, { useState, useEffect } from "react";
import { PROMO_FEATURES_ENABLED } from "../config/promoConfig";

export const Promos = (props) => {
  const [dynamicPromoEnabled, setDynamicPromoEnabled] = useState(null);
  const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://yuccan.tech';

  // Fetch current promo state from API
  useEffect(() => {
    const fetchPromoState = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/static-config/promo`);
        const result = await response.json();
        if (result.success) {
          setDynamicPromoEnabled(result.data.enabled);
        }
      } catch (err) {
        console.warn('Promos: Failed to fetch promo config, using static fallback');
      }
    };
    
    fetchPromoState();
    
    // Poll every 5 seconds to check for changes
    const interval = setInterval(fetchPromoState, 5000);
    return () => clearInterval(interval);
  }, [API_BASE_URL]);

  // Use dynamic state if available, otherwise fall back to static config
  const PROMOS_ENABLED = dynamicPromoEnabled !== null ? dynamicPromoEnabled : PROMO_FEATURES_ENABLED;

  // If promos section is disabled, return null (completely hidden)
  if (!PROMOS_ENABLED) return null;

  return (
    <div id="promos" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>Promos</h2>
          <p>
            Explore special offers and promotions on our services, designed to help get you further on your DX journey.
          </p>
        </div>
        {/* First row - 3 containers centered */}
        <div className="row">
          {props.data
            ? props.data.slice(0, 3).map((d, i) => (
                <div key={`${d.title}-${i}`} className="col-md-4 col-sm-6 col-xs-12">
                  <a 
                    href={`/promo${i + 1}`}
                    className="promo-item"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ 
                      cursor: 'pointer',
                      textDecoration: 'none',
                      color: 'inherit',
                      display: 'block'
                    }}
                  >
                    <div className="promo-icon">
                      <i className={d.icon}></i>
                    </div>
                    <div className="promo-content">
                      <h3>{d.title}</h3>
                      <p className="promo-description">{d.description}</p>
                    </div>
                    <div className="promo-bottom">
                      <div className="promo-offer">
                        <span className="offer-text">{d.offer}</span>
                        {d.discount && (
                          <span className="discount-badge">{d.discount}</span>
                        )}
                      </div>
                      <p className="promo-terms">{d.terms}</p>
                    </div>
                  </a>
                </div>
              ))
            : "Loading..."}
        </div>
        
        {/* Second row - 2 containers centered */}
        {props.data && props.data.length > 3 && (
          <div className="row">
            <div className="col-md-8 col-md-offset-2 col-sm-12">
              <div className="row">
                {props.data.slice(3).map((d, i) => (
                  <div key={`${d.title}-${i + 3}`} className="col-md-6 col-sm-6 col-xs-12">
                    <a 
                      href={`/promo${i + 4}`}
                      className="promo-item"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ 
                        cursor: 'pointer',
                        textDecoration: 'none',
                        color: 'inherit',
                        display: 'block'
                      }}
                    >
                      <div className="promo-icon">
                        <i className={d.icon}></i>
                      </div>
                      <div className="promo-content">
                        <h3>{d.title}</h3>
                        <p className="promo-description">{d.description}</p>
                      </div>
                      <div className="promo-bottom">
                        <div className="promo-offer">
                          <span className="offer-text">{d.offer}</span>
                          {d.discount && (
                            <span className="discount-badge">{d.discount}</span>
                          )}
                        </div>
                        <p className="promo-terms">{d.terms}</p>
                      </div>
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};